import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faThLarge,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faPlusCircle,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faDownload,
  faUpload,
  faSync,
  faTimesCircle,
  faHome,
  faUserCog,
  faShareSquare,
  faCheck,
  faCheckCircle,
  faRedo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faThLarge,
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faPlusCircle,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faDownload,
  faUpload,
  faSync,
  faTimesCircle,
  faHome,
  faUserCog,
  faShareSquare,
  faCheck,
  faCheckCircle,
  faRedo,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
